<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">발송내역</span>
            <span class="txt">회원에게 발송할 메시지 내역을 확인할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button class="on">발송 내역</button>
            <!-- <button @click="onClickRouter('/madmin/message/RefuseNum')">
                수신거부번호
            </button> -->
        </div>

        <div class="com-search-content">
            <div class="com-search-input mb-16">
                <input v-model="searchStr" placeholder="회원명, 전화번호" type="text" @keyup.enter="onEventSearch" />
                <button class="search-btn" @click="onEventSearch">검색</button>
            </div>

            <table class="com-table com-table-header">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>발신일</th>
                        <td colspan="3">
                            <div class="flex">
                                <div class="com-calendar-wrap">
                                    <single-calendar
                                        :start-date="startDate"
                                        @update="startDateUpdate"
                                    ></single-calendar>
                                    <span class="dash">~</span>
                                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                </div>
                                <select-form
                                    :select-data="['기간선택', ...periodTypeList]"
                                    :select-value="['', ...periodTypeValueList]"
                                    :selected-value="period"
                                    @update:set="(val) => (period = val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>발송 유형</th>
                        <td>
                            <div class="check-area">
                                <div class="check-btn">
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-1-1"
                                            checked
                                            name="check-1"
                                            type="radio"
                                            v-model="searchSmsType"
                                            value=""
                                        />
                                        <label for="check-1-1">전체</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-1-2"
                                            name="check-1"
                                            type="radio"
                                            v-model="searchSmsType"
                                            value="S"
                                        />
                                        <label for="check-1-2">SMS</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-1-3"
                                            name="check-1"
                                            type="radio"
                                            v-model="searchSmsType"
                                            value="M"
                                        />
                                        <label for="check-1-3">MMS</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-1-4"
                                            name="check-1"
                                            type="radio"
                                            v-model="searchSmsType"
                                            value="L"
                                        />
                                        <label for="check-1-4">LMS</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-1-5"
                                            name="check-1"
                                            type="radio"
                                            v-model="searchSmsType"
                                            value="K"
                                        />
                                        <label for="check-1-5">알림톡</label>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <th>발송 조건</th>
                        <td>
                            <div class="check-area">
                                <div class="check-btn">
                                    <div class="com-radio-txt">
                                        <input id="check-2-1" v-model="sendType" value="" name="check-1" type="radio" />
                                        <label for="check-2-1">전체</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-2-2"
                                            v-model="sendType"
                                            value="batch"
                                            name="check-1"
                                            type="radio"
                                        />
                                        <label for="check-2-2">자동 발송</label>
                                    </div>
                                    <div class="com-radio-txt">
                                        <input
                                            id="check-2-3"
                                            v-model="sendType"
                                            value="direct"
                                            name="check-1"
                                            type="radio"
                                        />
                                        <label for="check-2-3">직접 발송</label>
                                    </div>
                                    <!--div class="com-radio-txt">
                                        <input id="check-2-4" v-model="sendType" value="resv" name="check-1"
                                            type="radio" />
                                        <label for="check-2-4">예약 발송</label>
                                    </div-->
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-content com-msg-content">
            <table class="com-table com-table-hover">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>발송일시</button>
                        </th>
                        <th>발송 유형</th>
                        <th>발송 조건</th>
                        <th>수신인</th>
                        <th>총 발송 건수</th>
                        <th>발송 성공</th>
                        <th>발송 실패</th>
                        <th>금액</th>
                        <th>비고</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="h in filteredHistoryList" :key="h.c_message_id" @click="openPopup(h)">
                        <td>{{ h.requestedAt | timestampFilter2 }}</td>
                        <td>{{ convertSmsType(h.smsType) }}</td>
                        <td>{{ convertSendType(h.sendType) }}</td>
                        <td>{{ h.recvName }}</td>
                        <td>{{ h.totCnt }} 건</td>
                        <td>{{ h.successCount }} 건</td>
                        <td>
                            <span class="txt-red">{{ h.failureCount }} 건</span>
                        </td>
                        <td>{{ h.price | formatPrice }}</td>
                        <td>
                            {{ replaceErrorMessage(h.sendErrorMessage) }}
                        </td>
                        <td>
                            <button
                                v-if="h.sendType == 'resv' && canCancel(h.requestedAt) && h.resultCd != '2'"
                                type="button"
                                class="com-btn dark-gray"
                                @click.stop.prevent="cancelSend(h)"
                            >
                                발송 취소
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 발송내역 상세 레이어 팝업 -->
        <div v-show="sendHistoryDetailPop" class="layer-pop square">
            <div class="view-content w700">
                <button class="close" @click="sendHistoryDetailPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">발송 내역 상세</p>
                    <div class="send-history-detail-pop">
                        <div class="com-tab">
                            <button :class="{ on: activeTab === 'info' }" @click="activeTab = 'info'">발신 정보</button>
                            <button :class="{ on: activeTab === 'content' }" @click="activeTab = 'content'">
                                메시지 내용
                            </button>
                            <button :class="{ on: activeTab === 'status' }" @click="onStatusTabClicked">
                                발송 상태
                            </button>
                        </div>

                        <!-- 발신 정보 탭 -->
                        <div class="com-tab-cont info-tab-cont" v-if="activeTab === 'info'">
                            <table class="com-table">
                                <tbody>
                                    <tr>
                                        <th>발송 일시</th>
                                        <td v-if="selectedItem">{{ selectedItem.requestedAt | timestampFilter2 }}</td>
                                    </tr>
                                    <tr>
                                        <th>발송 유형</th>
                                        <td v-if="selectedItem">{{ convertSmsType(selectedItem.smsType) }}</td>
                                    </tr>
                                    <tr>
                                        <th>발송 조건</th>
                                        <td v-if="selectedItem">{{ convertSendType(selectedItem.sendType) }}</td>
                                    </tr>
                                    <tr>
                                        <th>수신인</th>
                                        <td v-if="selectedItem">{{ selectedItem.recvName }}</td>
                                    </tr>
                                    <tr>
                                        <th>발송 건수</th>
                                        <td v-if="selectedItem">{{ selectedItem.totCnt }} 건</td>
                                    </tr>
                                    <tr>
                                        <th>성공</th>
                                        <td v-if="selectedItem">{{ selectedItem.successCount }} 건</td>
                                    </tr>
                                    <tr>
                                        <th>실패</th>
                                        <td v-if="selectedItem">
                                            <span class="txt-red">{{ selectedItem.failureCount }} 건</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>사용 금액</th>
                                        <td v-if="selectedItem">{{ selectedItem.price | formatPrice }}</td>
                                    </tr>
                                    <tr>
                                        <th>비고</th>
                                        <td v-if="selectedItem">
                                            {{ replaceErrorMessage(selectedItem.sendErrorMessage) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 메시지 내용 탭 -->
                        <div
                            class="com-tab-cont content-tab-cont"
                            v-if="activeTab === 'content'"
                            style="position: relative"
                        >
                            <textarea
                                v-model="selectedItem.content"
                                readonly
                                style="background-color: white; color: black"
                            ></textarea>
                            <div style="display: flex">
                                <button
                                    class="com-btn blue"
                                    v-if="selectedItem.imageUrl1 && selectedItem.imageUrl1 !== 'https://'"
                                    @click="openImage(selectedItem.imageUrl1)"
                                >
                                    이미지 보기 1
                                </button>
                                <button
                                    class="com-btn blue"
                                    v-if="selectedItem.imageUrl2 && selectedItem.imageUrl2 !== 'https://'"
                                    @click="openImage(selectedItem.imageUrl2)"
                                >
                                    이미지 보기 2
                                </button>
                                <button
                                    class="com-btn blue"
                                    v-if="selectedItem.imageUrl3 && selectedItem.imageUrl3 !== 'https://'"
                                    @click="openImage(selectedItem.imageUrl3)"
                                >
                                    이미지 보기 3
                                </button>
                            </div>
                            <div
                                v-show="showModal"
                                @click="closeImage"
                                style="
                                    position: fixed;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    background-color: rgba(0, 0, 0, 0.5);
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                "
                            >
                                <img :src="selectedImage" style="max-width: 90%; max-height: 90%" />
                            </div>
                        </div>
                        <!-- 발송 상태 탭 -->
                        <div class="com-tab-cont status-tab-cont" v-if="activeTab === 'status'">
                            <table class="com-table">
                                <colgroup>
                                    <col style="width: 96px" />
                                    <col style="width: 96px" />
                                    <col style="width: 160px" />
                                    <col style="width: 96px" />
                                    <col style="" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>발송 유형</th>
                                        <th>수신인</th>
                                        <th>수신번호</th>
                                        <th>발송여부</th>
                                        <th>비고</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- 단건 발송일 경우 -->
                                    <tr v-if="!selectedItem.groupSerialNo || selectedItem.groupSerialNo == ''">
                                        <td>{{ convertSmsType(selectedItem.smsType) }}</td>
                                        <td>{{ selectedItem.recvName }}</td>
                                        <td>{{ formatPhone(selectedItem.recvNo) }}</td>
                                        <td>
                                            <span
                                                :class="{
                                                    'txt-blue': selectedItem.resultCd == '1',
                                                    'txt-red': selectedItem.resultCd != '1',
                                                }"
                                            >
                                                {{ selectedItem.resultCd == '1' ? '성공' : '실패' }}
                                            </span>
                                        </td>
                                        <td>{{ replaceErrorMessage(selectedItem.sendErrorMessage) }}</td>
                                    </tr>
                                    <!-- 묶음 발송일 경우 -->
                                    <template v-else>
                                        <tr v-for="(item, index) in groupedSendHistoryList" :key="index">
                                            <td>{{ convertSmsType(item.smsType) }}</td>
                                            <td>{{ item.recvName }}</td>
                                            <td>{{ formatPhone(item.recvNo) }}</td>
                                            <td>
                                                <span
                                                    :class="{
                                                        'txt-blue': item.resultCd == '1',
                                                        'txt-red': item.resultCd != '1',
                                                    }"
                                                >
                                                    {{ item.resultCd == '1' ? '성공' : '실패' }}
                                                </span>
                                            </td>
                                            <td>{{ replaceErrorMessage(item.sendErrorMessage) }}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { maskCustomerPhone } from '@/assets/js/customerPhone';
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import moment from 'moment';
import XLSX from 'xlsx';
import EventBus from '../../../assets/js/eventBus';

export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        filteredHistoryList() {
            if (this.selectedMsgType === 'all') {
                return this.historyList;
            }
            return this.historyList.filter((h) => h.smsType === this.selectedMsgType);
        },
    },
    filters: {
        formatPrice(value) {
            if (!value) return '0 원';
            return `${parseInt(value).toLocaleString()} 원`;
        },
    },
    watch: {
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchList();
        },
        startDate(newValue) {
            this.startDate = newValue;
        },
        endDate(newValue) {
            this.endDate = newValue;
        },
        searchSmsType(newValue) {
            this.searchSmsType = newValue;
            this.init();
        },
        sendOk(newValue) {
            this.sendOk = newValue;
            this.onSearchList();
        },
        sender(newValue) {
            this.sender = newValue;
            this.onSearchList();
        },
        sendType(newValue) {
            this.sendType = newValue;
            this.init();
        },
    },
    data() {
        return {
            sendHistoryDetailPop: false,
            selectedItem: null,
            activeTab: 'info',
            imagePop: false,
            centerId: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            // sortTypeList: [ ...this.$sortType ],
            // sortTypeValueList: [ ...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            groupedSendHistoryList: [],
            msgTypeList: ['SMS', 'LMS', 'MMS', 'KAKAO'], // 발송유형
            msgTypeValueList: ['S', 'L', 'M', 'K'], // 발송유형 value 값
            searchSmsType: '',
            sendOk: '',
            sender: '',
            staffNameList: [],
            staffValList: [],
            img: '', // '/img/temp/popup_1.png',
            selectedMsgType: 'all', // 선택된 발송 유형
            selectedCondition: '', // 선택된 발송 조건
            sendType: '', // 선택된 발송 조건
            selectedImage: null,
            showModal: false,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    methods: {
        canCancel(requestedAt) {
            const now = new Date();
            const requestDate = new Date(requestedAt);
            const thirtyMinutes = 30 * 60 * 1000; // 30분을 밀리초로 변환
            return requestDate.getTime() - now.getTime() > thirtyMinutes;
        },
        async cancelSend(item) {
            try {
                // {/admin/api/sms/:centerId/cancel, POST
                const response = await paymentApi.post(`/admin/api/sms/${this.centerId}/cancel`, {
                    ...item,
                });
                if (response.data.success) {
                    alert(response.data.message);
                    this.onSearchList();
                }
            } catch (error) {
                console.error('발송 취소 실패:', error);
            }
        },
        // 발송상태
        async onStatusTabClicked() {
            this.activeTab = 'status'; // 탭 상태 업데이트

            if (this.selectedItem.groupSerialNo) {
                // 묶음 발송인 경우
                await this.fetchGroupedSendHistory();
            }
        },
        async fetchGroupedSendHistory() {
            try {
                const response = await api.get(`/admin/api/center/${this.centerId}/message/sms/users`, {
                    params: {
                        // 필요한 파라미터
                        groupSerialNo: this.selectedItem.groupSerialNo,
                        centerId: this.centerId,
                    },
                });
                // 가져온 리스트를 컴포넌트의 데이터에 저장
                this.groupedSendHistoryList = response.data;
            } catch (error) {
                console.error('묶음 발송 내역 조회 실패:', error);
                alert('묶음 발송 내역 조회 중 오류가 발생했습니다.');
            }
        },
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.onSearchList(); // 목록
        },
        openImage(imageUrl) {
            this.selectedImage = imageUrl;
            this.showModal = true;
        },
        closeImage() {
            this.showModal = false;
        },
        // 발송내역 조회 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                this.setPageParams(data, 'center');
                this.historyList = data.items;
                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 발송내욕 조회 API
        async getCenterList() {
            // 스웨거 검색: 메시지발송 내역
            const msgType = 'S'; // 문자만 검색
            try {
                const response = await api.get(`/admin/api/center/${this.centerId}/message/sms`, {
                    params: {
                        msgType,
                        searchStr: this.searchStr,
                        smsType: this.searchSmsType, // S, M, L, K 로 필터링
                        startDate: this.startDate,
                        endDate: this.endDate,
                        success: this.sendOk,
                        sendNo: '',
                        sendType: this.sendType, // resv = 예약, batch = 자동, direct = 직접 필터링
                        ...this.pagingInfo,
                    },
                });
                return response;
            } catch (error) {
                console.error(error);
            }
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            (this.searchSmsType = ''), (this.searchStr = '');
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        convertSendType(type) {
            switch (type) {
                case 'batch':
                    return '자동발송';
                case 'direct':
                    return '직접발송';
                case 'resv':
                    return '예약발송';
                default:
                    return type; // 알 수 없는 타입의 경우 원래 값을 그대로 반환
            }
        },

        // 발송 유형 타입 변환
        convertSmsType(type) {
            switch (type) {
                case 'S':
                    return 'SMS';
                case 'M':
                    return 'MMS';
                case 'L':
                    return 'LMS';
                case 'K':
                    return '알림톡';
                default:
                    return type; // 알 수 없는 타입의 경우 원래 값을 그대로 반환
            }
        },
        convertSmsMoney(type) {
            if (type === 'S') {
                return '8.5';
            } else if (type === 'L') {
                return '25';
            } else if (type === 'M') {
                return '60';
            }
        },
        replaceErrorMessage(message) {
            if (message === 'undefined') {
                return '실패';
            } else if (message === '305') {
                return '잘못된 요청값 (휴대전화 번호)';
            } else if (message === '999') {
                return '시스템 오류';
            } else if (message === '101') {
                return '허용되지 않은 아이피';
            } else if (message === '301') {
                return '잘못된 요청값 (메시지 타입)';
            } else if (message === '302') {
                return '잘못된 요청값 (카카오 광고성 메시지 필수 표시사항 노출 여부 입력 오류)';
            } else if (message === '304') {
                return '잘못된 요청값 (전송 시간)';
            } else if (message === '306') {
                return '잘못된 요청값 (데이터가 존재하지 않음)';
            }
            return message;
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        getExcel() {
            // 목록을 통째로 시트로 만들기 때문에 수신번호를 가린 사본을 넘긴다
            const rows = this.historyList.map((row) => ({
                ...row,
                recvNo: maskCustomerPhone(row.recvNo),
            }));
            const dataWS = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'sendHistory');
            XLSX.writeFile(wb, 'sendHistory.xlsx');
        },

        viewImagePop(img) {
            this.imagePop = true;
            this.img = img;
        },
        openPopup(item) {
            console.log(item);
            this.selectedItem = item; // 선택한 항목 저장
            this.sendHistoryDetailPop = true; // 팝업 표시
            this.activeTab = 'info';
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        formatPhone(value) {
            let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
            phone = phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            return maskCustomerPhone(phone);
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        replaceErrorMessage(message) {
            if (!message) return '';

            switch (message.toLowerCase()) {
                case 'success':
                    return '성공';
                case 'internal server error':
                    return '오류 발생';
                default:
                    return message;
            }
        },
    },
};
</script>
<style lang="scss"></style>
